export default "__VITE_ASSET__TsX43dW8OnkpgnqP83IRHw__"